import { AppConstants } from "./app-constants";
import { DecoMetadata, ActionDecorator, EventDecorator, KeywordsDecorator, event, action, keywords, DefaultActionDecorator, defaultAction } from "./decorator-base";
import { bindAttribute, bindStyle, bindTextContent, bindToggleClass,bindHtml, bindModel, BaseModel } from "./decorator-bind";
import { log } from "./decorator-util";

import { registerElement, getBaseChildren, ResourceLoader } from "./util";

export { AppConstants, 
         log,
        registerElement, getBaseChildren, ResourceLoader,
        type DecoMetadata, EventDecorator, ActionDecorator, DefaultActionDecorator, KeywordsDecorator, event, action, defaultAction, keywords,
        BaseModel, bindModel, bindTextContent ,bindAttribute ,bindToggleClass, bindHtml, bindStyle 
};

/* 

    DO_NOT put any deco-base decorators.. it will have a issue with singleton extention pattern

*/
export class Base extends HTMLElement {

    [key: string]: any; // for method activation, generic call by method name
    protected schema: Record<string, unknown>;

    protected templateName?: string;
    protected templateClassName?: string;
    
    protected onReadyCallbacks : Function[] = [];
    protected onAttributeChangeCallbacks : Function[] = [];

    constructor() {
        super();       
        
        this.schema = {}; // later          
        console.groupCollapsed("Base constructor");        
        let componentName = this.getAttribute("component-name");        
        if (componentName) {
            const html = ResourceLoader.getResource(`${componentName?.replace(/\./g, "/")}.html`);                
            if ( html ) this.innerHTML = html as string;
               
            const css = ResourceLoader.getResource(`${componentName?.replace(/\./g, "/")}.css`)
            console.log("--------->",css)
            if ( css ) {
                    const cssSheet = new CSSStyleSheet();
                    cssSheet.replaceSync(`${css}`);
                    document.adoptedStyleSheets.push(cssSheet);
            }              
            this.init();          
        }  
        console.groupEnd();
    }
    
    callAsych = function(fn:Function){
        return new Promise(function (resolve, reject) {
        fn();
        resolve("Fn complete");    
    });
    }
    
    onReady(fn:Function){
        this.onReadyCallbacks.push(fn);
    }

    onAttributeChange(fn:Function){
        this.onAttributeChangeCallbacks.push(fn);
    }
     
    onAttributeChangeClear(){
        this.onAttributeChangeCallbacks = [];
    }
    

    //@event("click", "vk-base")
    start(event?:EventListener): void{
        console.log("Base:start");
        this.setAttribute("s-state", "start");
    }

    // Called when template ready or constructor finish
    init(){
        EventDecorator.getInstance().setupEvents(this);
        this.onReadyCallbacks.forEach(fn => {
            fn();
        });
    }
    connectedCallback(): void {
        console.log("Base:connected callback");
        
    }
    @log()
    registerEvent(eventName: string, querySelector: string, callBack: (event: Event) => void) {
        let el = this.querySelector(querySelector);    
        if (el && callBack) {
            console.log("Event registed", eventName)
            el.addEventListener(eventName, callBack as EventListener);
        }
    }
    setDState(dstate:string){
        this.setAttribute("d-state", dstate)
    }
    getDState(dstate:string){
        this.getAttribute("d-state");
    }

    setSState(state:string){
        this.setAttribute("s-state", state)
    }
    getSState(state:string){
        this.getAttribute("s-state");
    }
    // component attributes
    static get observedAttributes(): string[] {
        return ['s-state', 'd-state', 'component-name', 'instance'];
    }

    attributeChangedCallback(property: string, oldValue: string | null, newValue: string | null): void {
        if (oldValue === newValue) return;
        (this as any)[property] = newValue;
        console.log(`Attribute: ${property} changed to ${newValue}`);
        
        // Update all the attib change callbacks
        this.onAttributeChangeCallbacks.forEach(fn => {
            fn();
        });
    }
}

registerElement(Base);
